module.exports = "/images/ny-life1-14.jpg";